import React from 'react'

export const COLUMNS_DETALLE_POR_CONDICION_LINEA_3 = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealLinea6',
    label: 'Linea 6 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoCerealLinea5',
    label: 'Linea 5 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoCerealLinea7',
    label: 'Linea 7 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  }
]
export const COLUMNS_DETALLE_POR_CONDICION_LINEA_3_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealLinea5',
    label: 'Linea 5 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealLinea6',
    label: 'Linea 6 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealLinea7',
    label: 'Linea 7 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    width: 60,
    mantenerCase: true
  }
]
